import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { NavController, Platform } from '@ionic/angular';

import makeDebug from '../../../../makeDebug';
import { AuthService } from '../../services/auth.service';
import { ISyncContext } from '../contracts/sync/sync-context';
import { ISyncElement } from '../contracts/sync/sync-element';
import { RootHistorySetter as History } from '../contracts/sync/sync-endpoints';

const debug = makeDebug('sync:root-history-setter');

@Injectable({ providedIn: 'root' })
export class RootHistorySetter implements ISyncElement {
  public get name(): string {
    return History;
  }

  constructor(
    private _navController: NavController,
    private _authService: AuthService,
    private _ngZone: NgZone,
    private _platform: Platform,
    private _router: Router
  ) {}

  public async execute(context: ISyncContext): Promise<void> {
    debug('entered RootHistorySetter execute function');

    let navigationTarget = this._authService.redirectUrl;
    // Use window.location.pathname to get the actual browser URL (works consistently across tabs)
    const currentPath = window.location.pathname;

    // Only navigate if there's a redirect URL or if on login/callback pages
    if (!navigationTarget || navigationTarget === '//callback') {
      // If there's a current path that's not login, callback, or root, stay there
      if (currentPath && currentPath !== '/' && !currentPath.includes('/login') && !currentPath.includes('/callback')) {
        debug('Staying on current path:', currentPath);
        // Don't navigate, stay on current page
        context.executeOnlyOnce.set(this.name, true);
        return;
      }
      // Otherwise default to dashboard
      navigationTarget = '/dashboard';
    }

    await this._ngZone.run(() => this._navController.navigateRoot(navigationTarget));
    context.executeOnlyOnce.set(this.name, true);
  }
}
